import { fmt } from "@/lib/format";
import { useTab } from "@/hooks/useTab";
import { useFilters } from "@/hooks/useFilters";
import { Podium } from "@/components/cards/Podium";
import { RankingRow } from "@/components/cards/RankingRow";
import { KpiCard } from "@/components/cards/KpiCard";
import { EmptyState, ErrorState, SectionTitle, TabSkeleton } from "./shared";

const METRIC_LABELS: Record<string, string> = {
  messages: "Mensajes",
  conversations: "Conversaciones",
  credits: "Créditos",
  active_days: "Días activos",
};

/** Tab 1 — Global leaderboard (podium + KPIs + full ranking). */
export function GlobalTab() {
  const { filters } = useFilters();
  const { data, isPending, error } = useTab("global", filters);

  if (isPending) return <TabSkeleton />;
  if (error) return <ErrorState error={error} />;
  if (!data || (data.podium.length === 0 && data.ranking.length === 0)) {
    return <EmptyState title="Sin actividad en este periodo." />;
  }

  const metricLabel = METRIC_LABELS[filters.metric] ?? filters.metric;
  const { kpis } = data;

  return (
    <div className="flex flex-col gap-8">
      <section aria-label="Podio">
        <SectionTitle>Podio</SectionTitle>
        <Podium entries={data.podium} metricLabel={metricLabel} />
      </section>

      <section
        aria-label="Indicadores"
        className="grid grid-cols-4 gap-3"
      >
        <KpiCard label="Total usuarios" value={fmt(kpis.total_users)} />
        <KpiCard label="Activos en periodo" value={fmt(kpis.active_in_period)} />
        <KpiCard label="Total mensajes" value={fmt(kpis.total_messages)} />
        <KpiCard label="Mejor marca" value={fmt(kpis.best_mark)} />
      </section>

      <section aria-label="Ranking completo">
        <SectionTitle>Ranking completo</SectionTitle>
        <div className="flex flex-col gap-2">
          {data.ranking.map((row) => (
            <RankingRow
              key={row.uid}
              rank={row.rank}
              username={row.username}
              team={row.team}
              score={row.score}
              badges={row.badges}
              metricLabel={metricLabel}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
